import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock } from "vue"

import BusinessAdvertsList from 'src/components/business/BusinessAdvertsList.vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'AdvertsTabPanel',
  props: {
  slug: {required: true, type: String}
},
  setup(__props) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(BusinessAdvertsList, {
    "as-cards": true,
    "collapse-filter": true,
    "hide-owner": true,
    "show-extras": true,
    "show-filter": true,
    slug: __props.slug,
    "limit-results-per-page": 12
  }, null, 8, ["slug"]))
}
}

})